<template>
  <div class="newsList">
    <div class="left">
      <transition-group v-if="imgs.length>0" class="fade" name="flip-list" tag="ul">
        <li v-for="item in currImgs" :key="item.id" class="list-item" @mouseover="stop" @mouseout="start">
          <router-link :to="'/layout/article/155/'+item.basicId">
            <img :src="$store.state.baseUrl+item.src" />
            <div class="newsTitle">{{item.basicTitle}}</div>
          </router-link>
        </li>
      </transition-group>
      <ul class="num">
        <li v-for="item in imgs.length" :key="item"
         :class="{active: item == currImgs[0].id}"
         @click="choose(item)"
        ></li>
      </ul>
    </div>
    <div class="list">
      <div class="header">
        <h3>新闻中心</h3>
        <!-- <span class="more">更多>></span> -->
        <router-link class="more" to="/layout/news/155">更多>></router-link>
      </div>
      <ul>
        <li v-for="item in newsList" :key="item.basicId">
          <router-link :to="'/layout/article/155/'+item.basicId" class="title">{{item.basicTitle}}</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      newsList: [],
      imgs: [],
      currImgs: [],
      index: 0,
      interval: ""
    };
  },
  computed: {
    ...mapGetters(["getCategoryAppid"])
  },
  watch: {
    getCategoryAppid(id) {
      this.getNewsList(id);
    }
  },
  created() {
    this.getNewsList(this.$store.state.categoryAppid);
  },
  methods: {
    ...mapActions(["findPage"]),
    getNewsList(id) {
      this.findPage({
        basicCategoryid: 155,
        basicType: id,
        paeg: 1,
        size: 100
      }).then(res => {
        // console.log(res);
        this.newsList = res.data.dataList.slice(0, 5);
        this.imgs = [];
        let n = 1;
        let list = res.data.dataList;
        list.map(item => {
          if (item.basicThumbnails) {
            this.imgs.push({
              id: n++,
              src: item.basicThumbnails,
              basicId: item.basicId,
              basicTitle: item.basicTitle
            });
          }
        });
        this.imgs = this.imgs.slice(0, 5)
        this.currImgs = [this.imgs[0]];
        this.startChange();
      });
    },
    startChange: function() {
      var _this = this;
      clearInterval(_this.interval);
      if (_this.imgs.length > 1) {
        _this.interval = setInterval(function() {
          if (_this.index < _this.imgs.length - 1) {
            _this.index++;
          } else {
            _this.index = 0;
          }
          _this.currImgs.splice(0, 1, _this.imgs[_this.index]);
          // console.log(_this.currImgs)
        }, 3000);
      }
    },
    choose(id) {
      this.index = id - 1;
      this.currImgs.splice(0, 1, this.imgs[this.index]);
    },
    stop() {
      clearInterval(this.interval);
    },
    start() {
      var _this = this;
      if (_this.imgs.length > 1) {
        _this.interval = setInterval(function() {
          if (_this.index < _this.imgs.length - 1) {
            _this.index++;
          } else {
            _this.index = 0;
          }
          _this.currImgs.splice(0, 1, _this.imgs[_this.index]);
          // console.log(_this.currImgs)
        }, 3000);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.newsList {
  height: 250px;
}
.header {
  border-bottom: 3px solid #018fd7;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  padding: 5px;
  align-items: flex-end;
  .more {
    font-size: 12px;
  }
}
.newsList {
  width: 100%;
  display: flex;
  .left {
    width: 50%;
    position: relative;
  }
  .fade {
    width: 100%;
    position: relative;
    li {
      width: 100%;
      height: 250px;
      overflow: hidden;
      position: absolute;
      top: 0;
      left: 0;
      img {
        object-fit: contain;
        max-width: 100%;
        max-height: 100%;
        width: 100%;
      }
      .newsTitle {
        position: absolute;
        width: 100%;
        line-height: 28px;
        top: 0;
        left: 0;
        background-color: rgba($color: #000, $alpha: 0.5);
        color: #fff;
        text-align: center;
        font-size: 14px;
      }
    }
  }
  .num {
    display: flex;
    position: absolute;
    z-index: 1000;
    top: 240px;
    width: 100%;
    justify-content: center;
    align-items: center;
    li {
      width: 20px;
      height: 3px;
      border-radius: 1px;
      background-color: #018fd7;
      margin-left: 3px;
      cursor: pointer;
    }
  }
  .list {
    width: 50%;
    margin-left: 50px;
    ul {
      list-style: none;
      li {
        box-sizing: border-box;
        margin: 5px 0;
        height: 30px;
        line-height: 30px;
        cursor: pointer;
        border-bottom: 1px dashed #ccc;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box; /* 将对象作为弹性伸缩盒子模型显示 */
        -webkit-line-clamp: 1; /* 控制最多显示几行 */
        -webkit-box-orient: vertical; /* 设置或检索伸缩盒对象的子元素的排列方式 */
        padding-left: 5px;
      }
    }
  }
}

.flip-list-enter-active,
.flip-list-leave-active {
  transition: all 1.5s;
}
.flip-list-enter,
.flip-list-leave-active {
  opacity: 0;
}
.title {
  color: #000;
}

.active {
  background-color: #ff2222 !important;
}
</style>
